import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=5c951f85&scoped=true&"
import script from "./Tarjeta.vue?vue&type=script&lang=js&"
export * from "./Tarjeta.vue?vue&type=script&lang=js&"
import style0 from "./Tarjeta.vue?vue&type=style&index=0&id=5c951f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c951f85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
